import { gql } from '@apollo/client';

const GET_CLASSIFICATION_PERFORMANCE_ITEMS = gql`
  query GetClassificationPerformanceItems {
    classificationPerformanceItems {
      Id
      ClassificationMeasurementName
      ClassificationNumerator
      ClassificationDenominator
      ClassificationCalculationType
    }
  }
`;

export default GET_CLASSIFICATION_PERFORMANCE_ITEMS;
